import { render } from "./EnrollmentApproval.vue?vue&type=template&id=29a423b2&scoped=true"
import script from "./EnrollmentApproval.vue?vue&type=script&lang=js"
export * from "./EnrollmentApproval.vue?vue&type=script&lang=js"

import "./EnrollmentApproval.vue?vue&type=style&index=0&id=29a423b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a423b2"]])

export default __exports__